/**
 * Created by Ivan on 24.05.2025
 */

const HandTutorial = function () {
    return new TutorialScenario(HandTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createWaitStep(),
            TileGameTutorialHelper.createWaitStep(),
            TileGameTutorialHelper.createWaitStep(),
            TileGameTutorialHelper.createPlayCardStep(HandTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(HandTutorial.NAME);
            Game.currentGame.hand.setCards(HandTutorial.CONFIG.handValues);

            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(HandTutorial.NAME)
    });
};

HandTutorial.NAME = "hand";
HandTutorial.CONFIG = {
    handValues: ["2s", "6", "2"],
    force: "HandTutorialMessage",
    amountExtraCards: 8
};
